/**
 * Zentrale Regel für die Bildauswahl im Theme.
 *
 * Es sollen ausschliesslich Artikelbilder ab einer Mindest-Position angezeigt
 * werden. Bilder unterhalb dieser Position sind interne bzw. nicht für die
 * Shop-Ausgabe gedachte Bilder.
 */
export const MIN_IMAGE_POSITION = 300;

/**
 * Sortiert Bilder nach position und entfernt alles unterhalb der Mindest-Position.
 * Fallback: Hat ein Artikel kein Bild ab der Mindest-Position, wird die nach
 * position sortierte Gesamtliste zurückgegeben, damit nie eine leere
 * Bildfläche entsteht.
 *
 * @param {Array}  images       Liste von Bildobjekten mit position-Eigenschaft
 * @param {Number} minPosition  Mindest-Position (Default: 300)
 * @returns {Array}
 */
export function filterImagesByPosition(images, minPosition = MIN_IMAGE_POSITION)
{
    if (!Array.isArray(images) || !images.length)
    {
        return [];
    }

    const sortedImages = images
        .slice()
        .sort((imageA, imageB) => (imageA.position || 0) - (imageB.position || 0));

    const filteredImages = sortedImages.filter(image => (image.position || 0) >= minPosition);

    return filteredImages.length ? filteredImages : sortedImages;
}

/**
 * Liefert das Hauptbild aus einem Ceres-Bildobjekt ({ all: [], variation: [] })
 * oder direkt aus einer Bilder-Liste. Variations-Bilder haben Vorrang.
 *
 * @param {Object|Array} imageData
 * @param {Number}       minPosition
 * @returns {Object|null}
 */
export function getMainImage(imageData, minPosition = MIN_IMAGE_POSITION)
{
    if (!imageData)
    {
        return null;
    }

    const images = Array.isArray(imageData)
        ? imageData
        : ((imageData.variation && imageData.variation.length) ? imageData.variation : (imageData.all || []));

    return filterImagesByPosition(images, minPosition)[0] || null;
}
